import React, { useState } from 'react';
import { Modal, Input, Upload, Button, message } from 'antd';  // Remove Select component
import { UploadOutlined } from '@ant-design/icons';

const CreateWidgetModal = ({ show, onClose, onCreate, newWidget, setNewWidget, submitting }) => {
  const [fileList, setFileList] = useState([]);

  const handleUpload = (file) => {
    setFileList([file]);
    setNewWidget({ ...newWidget, image: file });
    return false; // Prevent immediate upload
  };

  const handleSubmit = () => {
    if (!newWidget.topic || !newWidget.header || !newWidget.description || !newWidget.image) {
      message.error('Please fill out all fields before submitting.');
      return;
    }
    onCreate(); // Trigger the create widget function
  };

  return (
    <Modal
      title="Create New Widget"
      visible={show}
      onCancel={onClose}
      onOk={() => {
        handleSubmit();
        // Clear file list after successful widget creation
        if (!submitting) setFileList([]);
      }}
      okText="Submit"
      cancelText="Cancel"
      confirmLoading={submitting} // Use confirmLoading to manage spinner
    >
      <Input
        placeholder="Topic"
        value={newWidget.topic}
        onChange={(e) => setNewWidget({ ...newWidget, topic: e.target.value })}
        style={{ marginBottom: '1rem' }}
      />
      <Input
        placeholder="Header"
        value={newWidget.header}
        onChange={(e) => setNewWidget({ ...newWidget, header: e.target.value })}
        style={{ marginBottom: '1rem' }}
      />
      <Input
        placeholder="Description"
        value={newWidget.description}
        onChange={(e) => setNewWidget({ ...newWidget, description: e.target.value })}
        style={{ marginBottom: '1rem' }}
      />
      <Upload
        beforeUpload={handleUpload}
        fileList={fileList}
        onRemove={() => {
          setFileList([]);
          setNewWidget({ ...newWidget, image: null });
        }}
      >
        <Button icon={<UploadOutlined />}>Upload Image</Button>
      </Upload>
    </Modal>
  );
};

export default CreateWidgetModal;
